// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__11xfF","footer":"ModalError_footer__1Ko4X"};